"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import styles from './Legend.module.scss.mjs';

const Legend = (props) => {
  const { children, className, ...rest } = props;
  const rootClassName = clsx(styles.legend, className);
  return /* @__PURE__ */ jsx("ul", { className: rootClassName, ...rest, children });
};

export { Legend, Legend as default };
//# sourceMappingURL=Legend.mjs.map
